import {Css, EdgeSingular, NodeSingular} from 'cytoscape';
import {CytoscapeEdgeData, FactNeighborhoodNodeType, GraphEntityStatus} from '../interface';
import {edgePropsByType} from './constants';

function getEdgeColor(status: GraphEntityStatus) {
    return function (edge: EdgeSingular) {
        const {presentation} = edge.data() as CytoscapeEdgeData;

        return edgePropsByType[presentation][status].color;
    };
}

export function getHiddenEdgeStyles(): Css.Edge {
    return {
        opacity: 0.4
    };
}

export function getUnhiddenEdgeStyles(): Css.Edge {
    return {
        opacity: 1
    };
}

export function getDefaultEdgeStyles(isHidden: boolean): Css.Edge {
    return {
        'line-color': getEdgeColor(GraphEntityStatus.default),
        'target-arrow-color': getEdgeColor(GraphEntityStatus.default),
        ...(isHidden ? getHiddenEdgeStyles() : getUnhiddenEdgeStyles())
    };
}

export function getSelectedEdgeStyles(): Css.Edge {
    return {
        'line-color': getEdgeColor(GraphEntityStatus.selected),
        'target-arrow-color': getEdgeColor(GraphEntityStatus.selected)
    };
}

export function getUnselectedNodeStyles(): Css.Node {
    return {
        'background-color': (node: NodeSingular) =>
            node.data().nodeType === FactNeighborhoodNodeType.INITIAL ? '#DDDDDD' : 'white',
        color: 'black'
    };
}

export function getSelectedNodeStyles(): Css.Node {
    return {
        'background-color': '#1C3C7D',
        color: 'white'
    };
}

export function getUnhoveredNodeStyles(): Css.Node {
    return {
        // @ts-ignore
        'outline-width': 0
    };
}

export function getHoveredNodeStyles(): Css.Node {
    return {
        // @ts-ignore
        'outline-width': 4
    };
}

export function getHiddenNodeStyles(): Css.Node {
    return {
        opacity: 0.4
    };
}

export function getUnhiddenNodeStyles(): Css.Node {
    return {
        opacity: 1
    };
}
